import { useState, useEffect, useRef } from "react";
import { io, Socket } from "socket.io-client";
import { getLoginData } from "../../../../../utility/AppStoreData";
import { BASE_URL } from "../../../../../services/streamApiClient";

// Derive socket URL from BASE_URL (remove /api suffix)
const SOCKET_URL = BASE_URL.replace("/api", "");

export const useStreamerSocket = (streamId: string | undefined) => {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [currentUser, setCurrentUser] = useState<{
    id: string;
    username: string;
    avatarUrl?: string;
  } | null>(null);

  // Fetch current user
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const loginData = await getLoginData();
        if (loginData) {
          setCurrentUser({
            id: loginData._id,
            username: loginData.Username || loginData.username,
            avatarUrl: loginData.ProfilePicture || loginData.profilePicture,
          });
        }
      } catch (err) {
        console.error("Failed to load user for socket:", err);
      }
    };
    fetchUser();
  }, []);

  // Connect socket
  useEffect(() => {
    if (!streamId || !currentUser) return;

    // Connect to /stream-room namespace
    const socketInstance = io(`${SOCKET_URL}/stream-room`, {
      transports: ["websocket"],
      autoConnect: true,
      reconnection: true,
      query: {
        userId: currentUser.id,
        username: currentUser.username,
        streamId: streamId,
      },
    });

    socketInstance.on("connect", () => {
      console.log("Streamer socket connected:", socketInstance.id);
    });

    setSocket(socketInstance);

    return () => {
      console.log("Disconnecting streamer socket");
      socketInstance.disconnect();
    };
  }, [streamId, currentUser]);

  return { socket, currentUser };
};
